import { ICustomerPortalTheme } from "@smartrr/shared/entities/CustomerPortalTheme";
import { defaultCustomerPortalThemeConfig } from "@smartrr/shared/themes/defaultThemeConfig";

import { CustomerSubReducer } from "@customer-app/state/typedCustomerRedux";
import { setI18NextResourceBundle } from "@customer-app/utils/useI18NextResourceBundle";

export interface IThemeReducerState {
  isLoading: boolean;
  theme: ICustomerPortalTheme;
}

const initialState: IThemeReducerState = {
  isLoading: false,
  theme: defaultCustomerPortalThemeConfig,
};

export const themeReducer: CustomerSubReducer<IThemeReducerState> = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING_THEME": {
      return {
        ...initialState,
        isLoading: true,
      };
    }

    case "LOADING_THEME_ERROR": {
      return {
        ...state,
        isLoading: false,
      };
    }

    case "LOADED_THEME": {
      action.payload.theme && setI18NextResourceBundle(action.payload.theme.translationOverrides);
      return {
        ...state,
        isLoading: false,
        theme: {
          ...state.theme,
          ...action.payload.theme,
        },
      };
    }

    default: {
      return state;
    }
  }
};
